
import { FormBody } from '@/containers/forms/FormBody'
import type { WizardPropertyAdditionalData } from 'BrokerTsLib/src/dtos'
import { Insurer } from 'BrokerTsLib/src/enums'
import { AdditionalPropertyInfoCpp } from './AdditionalPropertyInfoCpp'
import { AdditionalPropertyInfoDirect } from './AdditionalPropertyInfoDirect'
import { AdditionalPropertyInfoGcp } from './AdditionalPropertyInfoGcp'
import { AdditionalPropertyInfoKb } from './AdditionalPropertyInfoKb'
import { AdditionalPropertyInfoFloorAreas } from './AdditionalPropertyInfoKoop'

export const AdditionalInfoForm = ({ data }: { data: WizardPropertyAdditionalData }) => {

  return (
    <FormBody>
      {data.insurerId == Insurer.CPP &&
        <AdditionalPropertyInfoCpp />
      }

      {data.insurerId == Insurer.GeneraliCeskaPojistovna &&
        <AdditionalPropertyInfoGcp />
      }

      {(data.insurerId == Insurer.Kooperativa || data.insurerId == Insurer.Csob) &&
        <AdditionalPropertyInfoFloorAreas />
      }

      {data.insurerId == Insurer.Direct &&
        <AdditionalPropertyInfoDirect />
      }

      {data.insurerId == Insurer.KB &&
        <AdditionalPropertyInfoKb />
      }
    </FormBody>
  )
}